import getCorePopUpStore from "../../../../../stores/core/core-popup-store";
import WarningAlertHeaderText from "./WarningAlertHeaderText";
import { withLiteObserverAndTheme } from "../../../../et3-enhanced-render";
import SuccessAndHelperAlertHeaderText from "./SuccessAndHelperAlertHeaderText";

export const HeaderAlertText = withLiteObserverAndTheme(() => {
  const aletHeader = getCorePopUpStore().alertHeader.get();

  switch (aletHeader) {
    case "WARNING":
    case "OH_NO":
    case "EMPTY_STRING":
      return <WarningAlertHeaderText />;

    case "SUCCESS":
    case "HELPER":
    default:
      return <SuccessAndHelperAlertHeaderText />;
  }
});
